// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/elements/chat.less
// module id = 400
// module chunks = 0